//import anime from 'animejs/lib/anime.es.js';

import {
	gsap
} from "gsap";
import {
	ScrollToPlugin
} from "gsap/ScrollToPlugin";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

import {
	disableBodyScroll,
	enableBodyScroll,
	clearAllBodyScrollLocks
} from 'body-scroll-lock';

// sp menu event

var dbody = document.body

var drawer_overlay = document.createElement('div');
var sp_drawer_menu = document.getElementById('sp-drawer-menu');

drawer_overlay.classList.add('l-drawer-overlay');

//var js_toggle_btn = document.querySelectorAll('.js-toggle-btn');

//var l_header = document.querySelector('.l-header');
//var l_main_navi = document.querySelector('.l-main-navi');
//var l_menu_btn = document.querySelector('.l-menu-btn');
//var l_main_navi_overlay = document.querySelector('.l-main-navi-overlay');

var fade_duration = 200;

/*
for (let i = 0; i < js_toggle_btn.length; i++) {

	js_toggle_btn[i].addEventListener('click', function (e) {

		//console.log(e.currentTarget);

		var current_target = e.currentTarget;

		var current_toggle_contents = current_target.nextElementSibling;

		if (l_main_navi.classList.contains('is-open')) {

			//	l_header.classList.remove('is-open');
			l_main_navi.classList.remove('is-open');
			//	l_menu_btn.classList.remove('is-on');
			//	l_main_navi_overlay.classList.remove('is-on');

		}

		if (current_target.classList.contains('is-on')) {

			current_target.classList.remove('is-on');


			var toggle_contents = current_target.nextElementSibling;

			anime({
				targets: toggle_contents,
				delay: 10,
				opacity: 0,
				duration: fade_duration,
				easing: 'easeOutQuad',
				complete: function (anim) {

					toggle_contents.style.removeProperty('opacity');
					toggle_contents.style.removeProperty('display');
				}
			});

			if (window.matchMedia("(max-width: 767px)").matches) {

				enableBodyScroll(toggle_contents);
				clearAllBodyScrollLocks();

			}

		} else {
			/*
						for (let j = 0; j < js_toggle_btn.length; j++) {
			
							if (js_toggle_btn[j].classList.contains('is-on')) {
			
								var toggle_contents = js_toggle_btn[j].nextElementSibling;
								// close accordion
								toggle_contents.style.opacity = 1;
			
								js_toggle_btn[j].classList.remove('is-on');
			
								anime({
									targets: toggle_contents,
									delay: 10,
									opacity: 0,
									duration: fade_duration,
									easing: 'easeOutQuad',
									complete: function (anim) {
			
										toggle_contents.style.removeProperty('opacity');
										toggle_contents.style.removeProperty('display');
									}
								});
			
							}
						}
			
						current_toggle_contents.style.opacity = 0;
						current_toggle_contents.style.display = 'block';
						current_target.classList.add('is-on');
			
						anime({
							targets: current_toggle_contents,
							delay: 10,
							opacity: 1,
							duration: fade_duration,
							easing: 'easeOutQuad',
							complete: function (anim) {
			
								//	current_toggle_contents.style.removeProperty('display');
								current_toggle_contents.style.removeProperty('opacity');
								if (window.matchMedia("(max-width: 767px)").matches) {
									disableBodyScroll(current_target);
								}
							}
			
						});
			*/
/*	}

});

}*/

// js navi settings

var js_drawer_btn = document.querySelectorAll('.js-drawer-button');

//console.log(js_drawer_btn);

for (let i = 0; i < js_drawer_btn.length; i++) {


	js_drawer_btn[i].addEventListener('click', function (e) {

		var current_navi = e.currentTarget;

		if (sp_drawer_menu.classList.contains('is-open')) {

			gsap.fromTo(drawer_overlay, {
				opacity: 1,
				//display: 'block'
			}, {
				opacity: 0,
				//	display: 'none',
				duration: 0.4,
				onComplete: function () {
					//	sp_drawer_menu.classList.add('is-open');
					//	sp_drawer_menu.style.removeProperty('opacity');
					//	sp_drawer_menu.style.removeProperty('display');

					//	siteheader.style.removeProperty('position');
					//	siteheader.style.removeProperty('transform');
					dbody.removeChild(drawer_overlay);
				}
			});

			gsap.fromTo(sp_drawer_menu, {
				opacity: 1,
				right: '0%',
			}, {
				opacity: 0,
				duration: 0.4,
				right: '-100%',
				//	display: 'none',
				onComplete: function () {
					sp_drawer_menu.classList.remove('is-open');
					sp_drawer_menu.style.removeProperty('opacity');
					sp_drawer_menu.style.removeProperty('right');
					sp_drawer_menu.style.removeProperty('display');
					//	siteheader.style.removeProperty('transform');
				}
			});

			//console.log('B');

			enableBodyScroll(sp_drawer_menu);
			clearAllBodyScrollLocks();


		} else {

			//	console.log('open event');

			dbody.appendChild(drawer_overlay);

			gsap.fromTo(drawer_overlay, {
				opacity: 0,
				//display: 'block'
			}, {
				opacity: 1,
				//	display: 'none',
				duration: 0.4,
				onComplete: function () {
					//	sp_drawer_menu.classList.add('is-open');
					//	sp_drawer_menu.style.removeProperty('opacity');
					//	sp_drawer_menu.style.removeProperty('display');

					//	siteheader.style.removeProperty('position');
					//	siteheader.style.removeProperty('transform');
				}
			});

			gsap.fromTo(sp_drawer_menu, {
				opacity: 0,
				right: '-100%',
				display: 'block'
			}, {
				opacity: 1,
				right: '0%',
				//	display: 'none',
				duration: 0.4,
				onComplete: function () {
					sp_drawer_menu.classList.add('is-open');
					sp_drawer_menu.style.removeProperty('opacity');
					sp_drawer_menu.style.removeProperty('right');
					sp_drawer_menu.style.removeProperty('display');

					//	siteheader.style.removeProperty('position');
					//	siteheader.style.removeProperty('transform');
				}
			});

			//console.log('A');
			disableBodyScroll(sp_drawer_menu);

		}

		e.preventDefault();

	});

}

// ios page back event
window.addEventListener('pageshow', function (event) {

	//alert('asaaaaa');

	if (event.persisted) {
		unloadingWebsite();
	}

});


function unloadingWebsite() {
	// Do something just before the user leaves:
	// Eg: Hide/close your menu/reset settings/clear cookies etc, whatever you need to do.
	const dc = document.body;

	dc.classList.add('unloaded');

	if (sp_drawer_menu.classList.contains('is-open')) {

		//	alert('open');
		sp_drawer_menu.classList.remove('is-open');
		//sp_main_navi.classList.remove('is-open');
		//	l_main_navi.classList.remove('is-open');
		//	l_menu_btn.classList.remove('is-on');
		//	l_main_navi_overlay.classList.remove('is-on');

		dc.removeChild(drawer_overlay);

		enableBodyScroll(sp_drawer_menu);

		clearAllBodyScrollLocks();

	}


	window.setTimeout(function () {

		document.body.classList.remove('unloaded');

	}, 200);

}


// js navi settings

var js_submenu_open = document.querySelectorAll('.sub-menu-icon');
var current_toggle_contents_height;

for (let i = 0; i < js_submenu_open.length; i++) {


	js_submenu_open[i].addEventListener('click', function (e) {

		//	console.log('click');

		var current_target = e.currentTarget;
		var current_toggle_contents = current_target.nextElementSibling;


		if (current_target.classList.contains('is-on')) {

			current_target.classList.remove('is-on');
			current_toggle_contents.classList.remove('is-on');
			current_toggle_contents_height = current_toggle_contents.scrollHeight;

			//alert('close');
			gsap.fromTo(current_toggle_contents, {
				//y: 80,
				//position: 'absolute'
				height: current_toggle_contents_height
			}, {
				//	y: 0,
				height: 0,
				duration: 0.4,
				onComplete: function () {
					sp_main_navi.style.removeProperty('display');
					current_toggle_contents.style.removeProperty('height');
				}
			});


		} else {

			//	alert('open');
			current_target.classList.add('is-on');
			current_toggle_contents.classList.add('is-on');
			current_toggle_contents_height = current_toggle_contents.scrollHeight;
			//console.log(current_toggle_contents_height);
			gsap.fromTo(current_toggle_contents, {
				//y: 80,
				//position: 'absolute'
				height: 0
			}, {
				//	y: 0,
				height: current_toggle_contents_height,
				duration: 0.4,
				onComplete: function () {
					current_toggle_contents.style.removeProperty('height');

				}
			});


		}

	});
}